/* global __HOT__ */
/* eslint-disable import/no-unresolved */

/** @jsx h */

import { h, render } from 'preact'

import { testPositionSticky } from '@nrk/feature-tests'
import { simpleErrorReport, initialize as errorReportingInitialize } from '../lib/error-reporting'
import { nodelistToArray } from '../lib/nodelistToArray'
import { uuid } from '../lib/uuid'

import { root as rootElementClassName } from './components/App.css'
import { App } from './components/App'

console.log(window)

window[rootElementClassName] = window[rootElementClassName] || {}

function init (mapboxgl) {
  findElements().forEach(el => {
    el.id = uuid()
    window[rootElementClassName][el.id] = true
    // Extract preloaded state sent from server
    const preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'))
    const { errorEventTrackingEnabled } = preloadedState
    errorReportingInitialize(errorEventTrackingEnabled)
    simpleErrorReport().listenAndCatch()

    // Test if the browser is modern enough
    testPositionSticky(supported => {
      if (!supported) {
        simpleErrorReport().sendErrorReport({ message: 'Warning: This browser does not support `position: sticky`' })
      }
      if (!mapboxgl.supported()) {
        simpleErrorReport().sendErrorReport({ message: 'Warning: This browser does not support mapbox-gl' })
      }

      // ... and render with the exact same props
      el.className = el.className.replace('noJs', 'js')
      render(<App {...preloadedState} />, el, el.firstChild)
    })

    // Enable webpack hot-reloading
    if (__HOT__) {
      // Reload CSS file
      require('webpack/hot/emitter').on('webpackHotUpdate', currentHash => {
        document.querySelectorAll('link[href][rel=stylesheet]').forEach(link => {
          const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`)
          link.href = nextStyleHref
        })
      })

      // Reload and re-render React application
      // module.hot.accept('./client', () => {
      //  render(require('./components/App').default, el)
      // })
    }
  })
}

function findElements () {
  return nodelistToArray(document.getElementsByClassName(rootElementClassName))
    .filter(el => !isInitialized(el))
}

/*
function render (Component, mountNode, callback) {
  ReactDOM.hydrate(Component, mountNode, callback)
}
*/

function isInitialized (el) {
  return el.id && window[rootElementClassName][el.id]
}

window.initVerdensFarligsteLand = init



// WEBPACK FOOTER //
// ./src/v1/client.js